export default {
  state: {
    users: [],
  },
  mutations: {
    setUsers(state, payload) {
      state.users = payload.users;
    },
  },
  actions: {
    getUsers: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        window.axios
          .post(`/api/users/filter`, params)
          .then((r) => {
            commit({
              type: "setUsers",
              users: r.data.data,
            });

            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
};
